/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { compose } from 'redux';
import { object, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactHtmlParser from 'react-html-parser';

const styles = (theme) => {
    const { palette } = theme;
    return {
        descriptionWrapper: {
            '&.descriptionContainer': {
                '& .descriptionTitle': {
                    fontWeight: '700',
                    color: palette.common.black,
                    textTransform: 'uppercase',
                    borderBottom: `2px solid ${palette.common.black}`,
                    fontSize: '1rem',
                },
                '& p': {
                    '& span': {
                        fontWeight: 600,
                    },
                },
                '& ul': {
                    paddingLeft: '1rem',
                    '& li': {
                        marginBottom: '1.2em',
                    },
                    '& a': {
                        color: 'blue',
                    },
                },
                '&.mt-4': {
                    marginTop: '1.5rem',
                },
                '& .mb-4': {
                    marginBottom: '1.5rem',
                },
                '& .mb-3': {
                    marginBottom: '1rem',
                },
            },
        },
    };
};

const ProductDescription = (props) => {
    const { classes, description } = props;
    return (
        <div className={`${classes.descriptionWrapper} descriptionContainer mt-4`}>
            <div className="descriptionTitle mb-3" role="heading" aria-level="2">Details</div>
            <div className="mb-4">
                { ReactHtmlParser(description) }
            </div>
        </div>
    );
};

ProductDescription.propTypes = {
    description: string.isRequired,
    classes: object.isRequired,
};

export default compose(withStyles(styles))(ProductDescription);
